import React, { useState } from 'react';
import ProductData from '../../../Data/Products/ProductData';
import { useNavigate } from 'react-router-dom';

function BannerProducts() {

    const navigate = useNavigate();
    const [hoveredProduct, setHoveredProduct] = useState(null);

    const handleMouseEnter = (productName) => {
        setHoveredProduct(productName);
    };

    const handleMouseLeave = () => {
        setHoveredProduct(null);
    };

    const handleNavigate = (link) => {
        navigate(link);
    };

    return (
        <>
            <div className='header-home mt-5'>
                <div className='banner-heading' >
                    Smart <span style={{ color: "#000" }}>Insurance,</span> Starts Here.
                </div>
            </div>
            <div className='mt-5'>
                <div className='bannerProducts-Media d-flex gap-4 justify-content-center'>
                    {ProductData.data.map((item) => (
                        <div
                            key={item.id}
                            className='hero'
                            onMouseEnter={() => handleMouseEnter(item.product_name)}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => handleNavigate(item.link)}
                        >
                            <div className='home-card d-flex algin-items-center' >
                                <div className='box-for-banner-product mx-4'>
                                    <img className='card-img' src={item.image} alt={item.product_name} />
                                </div>
                                <h3 className='home-card-text'>{item.product_name}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* <Certified /> */}
        </>
    );
}

export default BannerProducts;
